import { PlayArrowRounded } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent } from '@mui/material';
import { SpaceGlassContainerBase } from 'src/components/SpaceGlassControl';
import { useFetchPropagations } from 'src/core/hooks';
import { ModalHeader } from 'src/pages/Shared/ModalSpaceGlass';

type ModalProps = {
  show: boolean;
  onClose: VoidFunction;
};

export function ModalStartPropagation(props: ModalProps) {
  const onCloseModal = () => {
    props.onClose();
  };

  const fetchPropagations = useFetchPropagations();

  const onSubmit = () => {
    fetchPropagations();

    onCloseModal();
  };

  return (
    <>
      <Dialog
        open={props.show}
        onClose={onCloseModal}
        fullWidth={true}
        aria-labelledby="max-width-dialog-title"
        maxWidth="md"
        PaperComponent={SpaceGlassContainerBase}
      >
        <ModalHeader
          title={'Start Propagation?'}
          onClose={onCloseModal}
          icon={<PlayArrowRounded />}
        />

        <DialogContent max-width="fit-content">
          Orbits need to be propagated in order to navigate in the timeline.
        </DialogContent>

        <DialogActions>
          <Button onClick={onCloseModal}>CANCEL</Button>

          <Button
            onClick={onSubmit}
            startIcon={<PlayArrowRounded />}
            variant="contained"
          >
            START PROPAGATION
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
